export default function booleanRender(params) {
    var value = params.value, trueLabel = params.trueLabel, falseLabel = params.falseLabel;
    if (value) {
        return trueLabel;
    }
    return falseLabel;
}
